import { tsUtils } from '@neo-one/ts-utils';
export function getForwardedValueType(type) {
    const aliasTypes = tsUtils.type_.getAliasTypeArgumentsArray(type);
    if (aliasTypes.length === 1) {
        return aliasTypes[0];
    }
    return undefined;
}

//# sourceMappingURL=getForwardedValueType.js.map
